import { gql } from "apollo-boost"

export const CREATE_MINISTRATION = gql`
  mutation CreateMinistration(
    $createMinistrationData: CreateMinistrationInput!
    $ministrationPeriodId: ID!
  ) {
    CreateMinistration(
      createMinistrationData: $createMinistrationData
      ministrationPeriodId: $ministrationPeriodId
    ) {
      id
      totalSaved
      paymentDate
      paymentAmount
      totalSupplied
      totalNoSupplied
    }
  }
`
